// The BE persists a contact's enrichment status as 'success'
// (ENRICHMENT_STATUS.SUCCESS) and returns it raw on cached reads (keyContacts,
// person-details). The FE reveal hook (useContactReveal) and all consumers
// (ContactCard, ContactInformationSection, KeyContacts cost/skip logic) use
// 'found' for that same "value present" state. Normalising cached reads to the
// FE convention at the ingestion boundary keeps every 'found' check working for
// BOTH session reveals and previously-revealed (cached) contacts — without which
// revealed values don't show on reload and the bulk skip-cost mis-counts. TD-2079.
export const REVEALED_STATUS_FOUND = 'found';

const normalizeOne = (status) => (status === 'success' ? REVEALED_STATUS_FOUND : status);

/**
 * Normalise a contact/relation's persisted enrichment status fields in place
 * (BE 'success' → FE 'found'; other values pass through). Returns the same
 * object for chaining. Safe on null/undefined.
 *
 * @param {object} contact - carries enrichment_status_email / enrichment_status_phone
 */
export const normalizeContactEnrichmentStatus = (contact) => {
  if (!contact) return contact;
  if (contact.enrichment_status_email) {
    contact.enrichment_status_email = normalizeOne(contact.enrichment_status_email);
  }
  if (contact.enrichment_status_phone) {
    contact.enrichment_status_phone = normalizeOne(contact.enrichment_status_phone);
  }
  return contact;
};
